import React, { useEffect, useRef } from "react";

import { Link } from "react-router-dom";
import ConfirmModal from "../../Components/ConfirmModal/ConfirmModal";
import ContentHeader from "../../Components/ContentHeader/ContentHeader";
import Loading from "../../Components/Loading/Loading";
import Table from "../../Components/Table/Table";
import Search from "../../Components/Search/Search";
import RrbDropdown from "../../Components/RRBDropdown/RrbDropdown";
import AuditFormAnswerField from "../../Components/AuditFormAnswerField/AuditFormAnswerField";
import CustomToast from "../../Components/CustomToast/CustomToast";

function ECAAuditUi({
  data,
  loading,
  deleteAdminFn,
  containerRef,
  toast,
  setBoxes,
  boxes,
  handleSubmit,
  error,
  setError,
  questionD,
  validateQuestions,
}) {
//  console.log(data,'data')
// const updatedData = data?.filter((d, index) => {
 
//   return d?.question !== 'City';
// })
console.log(boxes,'boxes22')
// console.log(questionD[44]?.sub_question,'daat')
console.log(data,'hello')
  return (
    <div>
      {loading ? (
        <Loading />
      ) : (
        <>
          {/* Content Wrapper. Contains page content */}
          <div className="content-wrapper">
            {/* Content Header (Page header) */}
            <ContentHeader
              title={"Audit Questions"}
              buttonName={""}
              buttonBoolean={false}
              pageName={""}
              linkPath={""}
            />

            {/* Main content */}
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-12">
                    <div className="card">
                      <div className="card-body" ref={containerRef}>
                        {toast && (
                          <CustomToast
                            text={toast?.message}
                            type={toast?.type}
                          />
                        )}

                        <>
                        {data?.length >= 0 && Array.isArray(data)
                            ? data
                                .sort((a, b) => a.sequence - b.sequence)
                                .map((box, index) => {

                                  const errors = error?.filter(
                                    (val) => val?.ind == index
                                  );

                                  return (
                                    <div
                                      id={box?.id}
                                      // onDragOver={(ev) => ev.preventDefault()}
                                      className=" border border-gray rounded w-100 h-100 p-2 mt-2 cursor-pointer"
                                    >
                                      <div className="d-flex justify-content-between ">
                                        <div className="d-flex">
                                          {/* <i class="fas fa-grip-vertical"></i> */}
                                          <h6 className="ml-2">
                                          Q. {index + 1} {box?.question}{" "}
                                            {box?.mandatory ? (
                                              <span className="text-red">
                                                *
                                              </span>
                                            ) : null}
                                            {box?.reference_para ? (
                                              <span className="ml-2">
                                                ({box?.reference_para})
                                              </span>
                                            ) : null}
                                          </h6>
                                        </div>
                                      </div>
                                      {/* <hr className="my-1"></hr> */}
                                      <div className="px-2">
                                        {box?.checkbox_type == "multiple" ? (
                                          Array.isArray(box?.sub_question) && box?.sub_question?.map((val, ind) => {
                                            const suberrors = error?.filter(
                                              (val) =>
                                                val?.ind == index &&
                                                val?.subInd == ind
                                            );

                                            return (
                                              <div className="p-2">
                                                <div>
                                                  <h6>
                                                    Q.{index + 1}.{ind + 1}{" "}
                                                    {val?.question}{" "}
                                                    {val.mandatory ? (
                                                      <span className="text-red">
                                                        *
                                                      </span>
                                                    ) : null}
                                                  </h6>
                                                </div>
                                                <AuditFormAnswerField
                                                  values={val}
                                                  index={index}
                                                  subIndex={ind}
                                                  subQuestion={true}
                                                  setBoxes={setBoxes}
                                                  boxes={boxes}
                                                  error={suberrors[0]}
                                                  setError={setError}
                                                  validateQuestions={validateQuestions}
                                                />
                                              </div>
                                            );
                                          })
                                        ) : (
                                          <>
                                            <AuditFormAnswerField
                                              values={box}
                                              index={index}
                                              setBoxes={setBoxes}
                                              boxes={boxes}
                                              error={errors[0]}
                                              setError={setError}
                                              validateQuestions={
                                                validateQuestions
                                              }
                                            />
                                          </>
                                        )}
                                      </div>
                                    </div>
                                  );
                                })
                            : "No Data Available"}
                        </>
                        <div className="card-footer d-flex justify-content-end">
                          <button className="blue-btn" onClick={handleSubmit}>
                            {/* {formik?.dirty ? (
                        <div class="spinner-border" role="status">
                          <span class="sr-only">Loading...</span>
                        </div>
                      ) : (
                        "Submit"
                      )} */}
                            Submit
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </>
      )}

      <ConfirmModal
        confirmFn={deleteAdminFn}
        text={"Are you sure, you want to Delete?"}
        buttonText={"Delete"}
      />
    </div>
  );
}

export default ECAAuditUi;
